import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Badge from 'react-bootstrap/Badge'
import {CSSTransition} from 'react-transition-group'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Link, useNavigate} from 'react-router'
import {useContext, useEffect, useRef, useState} from 'react'
import {Alert} from 'react-bootstrap'
import useFetch from '../../../hooks/useFetch'
import Loader from '../../ui/loader/Loader'
import AchatsAPI from '../../../services/AchatsAPI'
import {ShopItem} from './ShopItem.tsx'
import AlertCustom from '../../ui/alert/AlertCustom'
import {CartContext} from '../../../contexts/CartContext'
import Count from '../../ui/page/Count'
import Select from '../../ui/form/Select'
import {useStoreShopClosure} from '../../../store/useStoreShopClosure.ts'

const Achats = () => {
    const {cartItems} = useContext(CartContext)
    const [sortType, setSortType] = useState('articlesExtranetOrdre')
    const [sortOrder, setSortOrder] = useState('asc')
    const [currentPage, setCurrentPage] = useState(1)
    const [reload, setReload] = useState(false)
    const navigate = useNavigate()
    const nodeRef = useRef(null)
    const shopIsClosed = useStoreShopClosure((state) => state.shopIsClosed)

    const [
        {data: achats, totalItems, isLoading, isError},
        fetchData,
    ] = useFetch(AchatsAPI.getAchats(sortType, sortOrder))

    // Gestion du changement d'url
    useEffect(() => {
        if (reload) {
            fetchData(AchatsAPI.getAchats(sortType, sortOrder, currentPage))
        }
    }, [sortType, sortOrder, currentPage])

    useEffect(() => {
        if (shopIsClosed) {
            navigate('/tableau-de-bord')
        }
    })

    // Gestion du changement de page
    const handlePage = (page) => {
        setCurrentPage(page)
        setReload(true)
    }

    // Gestion du changement de filtre
    const handleSortType = (event) => {
        const {selectedIndex} = event.target.options
        setCurrentPage(1)
        setSortOrder('asc')
        setSortType(event.target.options[selectedIndex].getAttribute('id'))
        setReload(true)
    }

    // Gestion du changement de tri
    const handleSortOrder = () => {
        const sort = sortOrder === 'asc' ? 'desc' : 'asc'
        setCurrentPage(1)
        setSortOrder(sort)
        setReload(true)
    }

    return (
        <>
            <Col>
                <Row className={'d-flex align-items-center mb-2'}>
                    <Col xs={12} md={6} className="">
                        <h1>Boutique Florajet</h1>
                    </Col>
                    <Col xs={12} md={6} className={'text-right'}>
                        <Link
                            to="../panier"
                            role="button"
                            className="btn btn-primary btn-rounded ff-bold">
                            <FontAwesomeIcon
                                icon="shopping-cart"
                                color="white"
                                className="mr-2"
                            />
                            <span>Mon panier</span>
                            <Badge pill variant="light" className="ml-1">
                                {cartItems.length}
                            </Badge>
                        </Link>
                    </Col>
                </Row>
                <Row className={'mb-4'}>
                    <Col xs={12} md={3} className={'d-flex align-items-end'}>
                        <Select
                            controlId="achatsSelect"
                            label="Trier par"
                            classNamesForm="mr-3"
                            defaultValue="Meilleures ventes"
                            onChange={handleSortType}
                            options={
                                <>
                                    <option id="articlesExtranetOrdre">
                                        Meilleures ventes
                                    </option>
                                    <option id="articlesExtranetReference">
                                        Référence
                                    </option>
                                    <option id="articlesExtranetLibelle">
                                        Libellé
                                    </option>
                                    <option id="articlesExtranetDescription">
                                        Description
                                    </option>
                                    <option id="articlesExtranetStock">
                                        Produits en stock
                                    </option>
                                    <option id="articlesExtranetMaxi">
                                        Max
                                    </option>
                                </>
                            }
                        />
                    </Col>
                    <Col xs={12} md={6} className={'d-flex align-items-end'}>
                        <Alert
                            id={'franco'}
                            variant={'warning'}
                            className={'mb-0 text-center w-100'}
                        >
                            <b>Profitez du franco offert !</b><br/> Les frais de port sont offerts dès 150 € HT d'achats d'accessoires.
                        </Alert>
                    </Col>
                    <Col
                        xs={12}
                        md={3}
                        className={
                            'text-right d-flex flex-row align-items-end'
                        }>
                        <FontAwesomeIcon
                            onClick={() => handleSortOrder()}
                            size="lg"
                            icon={`sort${
                                sortOrder === 'asc'
                                    ? '-amount-up-alt'
                                    : '-amount-down'
                            }`}
                            color="var(--grey-darker)"
                            className="mr-3 ml-auto mb-3"
                        />

                        <Count
                            totalItems={totalItems}
                            name="article"
                            classNames="mb-3"
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>{isLoading && <Loader />}</Col>
                    {!isLoading && !isError && (
                        <CSSTransition
                            in={true}
                            appear={true}
                            timeout={500}
                            unmountOnExit
                            nodeRef={nodeRef}
                            classNames="fade">
                            <Col xs={12}>
                                <Row>
                                    {achats.map((item, index) => (
                                        <ShopItem key={index} shopItem={item} />
                                    ))}
                                </Row>
                            </Col>
                        </CSSTransition>
                    )}
                </Row>
            </Col>

            <AlertCustom
                heading={isError.heading}
                variant={isError.variant}
                bodyIcon={isError.icon}
                bodyContent={isError.content}
                bodyContentBold={isError.message}
                bodyContentItalic={isError.detail}
                transition={!!isError}
            />
        </>
    )
}

export default Achats
